import { FC } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { OutlinedEmptyStateIcon } from '../Icons';
import { WbNoData } from './WbNoData';

const useStyles = makeStyles(
  () => ({
    textNoDataContent: {
      textAlign: 'center',
      maxWidth: '400px',
    },
  }),
  { name: 'WbNoMatchingData' },
);

export const WbNoMatchingData: FC = () => {
  const classes = useStyles();
  return (
    <WbNoData
      header="Sorry, no results were found"
      text={
        <Typography className={classes.textNoDataContent}>
          Try running the search again, using a different combination of terms
          or filters.
        </Typography>
      }
      icon={
        <div style={{ marginTop: '8px' }}>
          <OutlinedEmptyStateIcon />
        </div>
      }
      fillContainer
    />
  );
};
